import { processSteps, achievements } from '~/data/siteData'
import { ProcessSection, AchievementsSection } from '~/components/Sections'

export default function ProcessPage() {
  return (
    <main>
      <section className="page-hero section-pad muted">
        <div className="container">
          <span className="eyebrow">How It Works</span>
          <h1 className="page-hero-title">From Enquiry to Production</h1>
          <p className="page-hero-desc">
            A simple, transparent process — consult, demo, install, support.
            We make sure you are production-ready with the right machine.
          </p>
        </div>
      </section>
      <ProcessSection items={processSteps} />
      <AchievementsSection items={achievements} />
    </main>
  )
}
